import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import { Button } from 'reactstrap';
/* Models */
import { DealerInfoEntities } from 'client/data/models/dealer-info';
import { InventoryEntities } from 'client/data/models/inventory';
/* Constants */
import { INVENTORY_TYPES_LOWERCASE } from 'client/constants/inventory-types';
/* Utils */
import { toDisplayString } from 'site-modules/shared/utils/phone-format';
import { updateCreativeId } from 'site-modules/financing/utils/update-creative-id';
import { Link } from 'site-modules/shared/components/link/link';
import { srpLinkBuilder } from 'site-modules/shared/utils/srp-link-constructor';

export function SystemErrorScreen({ vehicle = {}, dealerInfo = {}, isMatchingVIN = false, isPreVinFlow = false }) {
  const dealerName = get(vehicle, 'dealerInfo.name', get(dealerInfo, 'name', ''));
  const phone = get(
    vehicle,
    'dealerInfo.phoneNumbers.trackable',
    get(
      vehicle,
      'dealerInfo.phoneNumbers.ppTrackable',
      get(vehicle, 'dealerInfo.phoneNumbers.basicTrackable', get(vehicle, 'dealerInfo.phoneNumbers.basic', {}))
    )
  );
  const address = get(dealerInfo, 'address', {});
  const zip = get(address, 'zip', '');
  const stateCode = get(address, 'stateCode', '');
  const street = get(address, 'street', '');
  const city = get(address, 'city', '');

  return (
    <div data-tracking-parent={updateCreativeId({ isPreVinFlow, isMatchingVIN, trackingParent: 'system_error' })}>
      <h4 className="size-20 mb-2 fw-normal">Sorry, something went wrong.</h4>
      <p className="mb-2">
        There seems to be an issue processing your information. Please try again later to see if the issue has been
        resolved.{isPreVinFlow ? ' In the meantime, feel free to continue shopping thousands of local vehicles.' : ''}
      </p>
      <div className="d-flex justify-content-center">
        {isPreVinFlow ? (
          <Button
            className="text-capitalize size-16"
            color="primary"
            tag={Link}
            to={srpLinkBuilder({
              inventorytype: `${INVENTORY_TYPES_LOWERCASE.USED},${INVENTORY_TYPES_LOWERCASE.CPO}`,
            })}
          >
            See All For Sale
          </Button>
        ) : (
          <div className="info-wrapper p-1 bg-gray-extra-light mb-2">
            <h5 className="size-20 mb-1">You can contact the dealer directly.</h5>
            <p>{dealerName} can help you find financing, so contact the dealer directly to explore your options.</p>
            <hr className="mb-1" />
            <div className="d-flex mb-1 px-1_25">
              <i className="icon-location me-0_5 mt-0_25" aria-hidden />
              <div>
                <div className="fw-bold">{dealerName}</div>
                <div className="medium">
                  <span>{street},</span>
                  <br />
                  <span>
                    {city}, {stateCode} {zip}
                  </span>
                  <br />
                  <span>{toDisplayString(phone)}</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

SystemErrorScreen.propTypes = {
  vehicle: InventoryEntities.InventoryVin,
  dealerInfo: DealerInfoEntities.DealerInfo,
  isMatchingVIN: PropTypes.bool,
  isPreVinFlow: PropTypes.bool,
};
